'use strict';

function requireCompleteSignInDirective () {
  var link = (scope, el) => {
    el.addClass('require-complete-sign-in');
  };

  return {
    link,
    controller: 'requireCompleteSignInController',
    controllerAs: 'vm',
    templateUrl: 'requireCompleteSignIn/requireCompleteSignIn.tpl.html'
  };
}

module.exports = requireCompleteSignInDirective;



// WEBPACK FOOTER //
// ./src/app/requireCompleteSignIn/requireCompleteSignInDirective.js